<template>
  <tables
    :dataset="sharkGroupData"
    type="groups"
    :queryParams.sync="queryParams"
    :headers="headers"
    :loading="_loading"
  >
    <template v-slot:content="slotProps">
      <div
        v-if="!showMobileView && _client.client_name !== 'shark'"
        style="width:100%;"
      >
        <v-row
          class="d-flex justify-space-between pl-3 pr-3"
          v-if="!showMobileView"
          style="font-size:12px;"
        >
          <div
            class="d-flex align-center"
            style="width:10%; overflow: ellipses;"
          >
            {{ slotProps.data.group_name }}
          </div>
          <div
            class="d-flex align-center"
            style="width:10%; overflow: ellipses;"
          >
            {{ slotProps.data.screens.length }}
          </div>
          <div
            class="d-flex align-center"
            style="width:10%; overflow: ellipses;"
          >
            {{ getCheckedIn(slotProps.data.screens) }}
          </div>
          <div
            class="d-flex align-center"
            style="width:10%; overflow: ellipses;"
          >
            {{ getCheckedOut(slotProps.data.screens) }}
          </div>
          <div
            class="d-flex align-center"
            style="width:10%; overflow: ellipses;"
          >
            {{ getOverdue(slotProps.data.screens) }}
          </div>
          <div
            class="d-flex align-center"
            style="width:10%; overflow: ellipses;"
          >
            {{ getOneway(slotProps.data.screens) }}
          </div>
          <div
            class="d-flex align-center"
            style="width:10%; overflow: ellipses;"
          >
            {{ getRoundtrip(slotProps.data.screens) }}
          </div>
        </v-row>
      </div>
      <div v-if="showMobileView && _client.client_name === 'shark'">
        <v-row>
          <v-col cols="6" class="px-0 pt-0 pb-2">
            <v-card-text class="py-0 text-h6 font-weight-medium">
              {{ slotProps.data.group_name }}
            </v-card-text>
          </v-col>
          <v-col cols="6" class="px-0 py-1">
            <v-card-text
              v-if="slotProps.data.screens[0]"
              class="text-right py-0 text-subtitle-1 grey--text font-italic"
            >
              {{ slotProps.data.screens[0].trip_type }}
            </v-card-text>
            <v-card-text
              v-else
              class="text-right py-0 text-subtitle-1 grey--text font-italic"
            >
              {{ 'Unknown' }}
            </v-card-text>
          </v-col>
        </v-row>
        <v-divider />
        <v-row style="height:30px;" class="d-flex">
          <v-col cols="6" class="px-0 py-1">
            <v-card-text class="pb-0 pt-0">
              Number of Golf Cars
            </v-card-text>
          </v-col>
          <v-col cols="6" class="px-0 py-1">
            <v-card-text
              class="text-right pb-0 pt-0 text-subtitle-2 font-weight-medium"
            >
              {{ slotProps.data.screens.length }}
            </v-card-text>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="5" class="px-0 py-1">
            <v-card-text class="pb-0 pt-0">
              Area
            </v-card-text>
          </v-col>
          <v-col cols="7" class="px-0 pb-0 pt-0">
            <v-card-text
              class="text-right py-0 text-subtitle-2 font-weight-medium"
            >
              {{ getAreaName(slotProps.data.area_id) }}
            </v-card-text>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="5" class="px-0 pb-0 pt-0">
            <v-card-text class="py-0">
              City
            </v-card-text>
          </v-col>
          <v-col cols="7" class="px-0 pb-0 pt-0">
            <v-card-text
              class="text-right py-0 text-subtitle-2 font-weight-medium text-truncate"
            >
              {{ slotProps.data.city }}
            </v-card-text>
          </v-col>
        </v-row>
      </div>
      <div
        v-else-if="!showMobileView && _client.client_name === 'shark'"
        style="width:100%;"
      >
        <v-row
          class="d-flex justify-space-between pl-3 pr-3"
          style="font-size:12px;"
        >
          <div
            class="d-flex align-center"
            style="width:10%; overflow: ellipses;"
          >
            {{ capitalize(slotProps.data.group_name) }}
          </div>
          <div
            class="d-flex align-center"
            style="width:10%; overflow: ellipses;"
          >
            {{ getLaunchMode(slotProps.data.launch_mode) }}
          </div>
          <div
            class="d-flex align-center"
            style="width:10%; overflow: ellipses;"
          >
            {{ getGroupArea(slotProps.data.screens) }}
          </div>
          <div
            class="d-flex align-center"
            style="width:10%; overflow: ellipses;"
          >
            {{ slotProps.data.screens.length }}
          </div>
          <div
            class="d-flex align-center"
            style="width:10%; overflow: ellipses;"
          >
            {{ slotProps.data.address.city }},
            {{ slotProps.data.address.state }}
          </div>
          <div
            class="d-flex align-center"
            style="width:10%; overflow: ellipses;"
            v-if="slotProps.data.contact"
          >
            {{ slotProps.data.contact.phone }}
          </div>
          <div
            v-else
            class="d-flex align-center"
            style="width:10%; overflow: ellipses;"
          >
            None
          </div>
          <div
            class="d-flex align-center"
            style="width:10%; overflow: ellipses;"
          >
            {{ formatDate(slotProps.data.last_activity) }}
          </div>
        </v-row>
      </div>
    </template>
  </tables>
</template>
<script>
import { mapGetters, mapMutations } from 'vuex';
import moment from 'moment';
import Tables from '@/components/app/Table';
import { MobileView } from '@/mixins';

export default {
  props: ['sharkGroupData'],
  components: {
    Tables,
  },
  mixins: [MobileView],
  data: () => ({
    untilHeaders: [
      'Group Name',
      'Total Devices',
      'Checked-In',
      'Checked-Out',
      'Overdue',
      'One-Way',
      'Roundtrip',
    ],
    bazzbiUtilHeaders: [
      'Group Name',
      'Total Devices',
      'Checked-In',
      'Checked-Out',
      'Overdue',
      'QR Code',
      'Digital Key',
    ],
    sharkUtilHeaders: [
      'Course Name',
      'Launch Mode',
      'Active',
      'Total Active Golf Cars',
      'City, State',
      'Contact',
      'Last Activity',
    ],
  }),
  computed: {
    ...mapGetters({
      _dataset: 'reports/getGroups',
      _getQueryParams: 'reports/getQueryParams',
      _client: 'account/getCurrentClient',
      _areas: 'areas/getAreas',
      _rounds: 'reports/getSessions',
      _loading: 'reports/getGroupsTableLoading',
    }),
    queryParams: {
      get() {
        return this._getQueryParams;
      },
      set(val) {
        this._setQueryParams(val);
      },
    },
    headers() {
      if (this._client.client_name === 'bazzbi') {
        return this.bazzbiUtilHeaders;
      }
      if (this._client.client_name === 'avis') {
        return this.untilHeaders;
      }
      return this.sharkUtilHeaders;
    },
  },
  methods: {
    ...mapMutations({
      _setQueryParams: 'reports/setQueryParams',
    }),
    getCheckedIn(arrayOfScreens) {
      let count = 0;
      for (let i = 0; i < arrayOfScreens.length; i++) {
        if (arrayOfScreens[i].session_status === 'checked in') {
          count++;
        }
      }
      return count;
    },
    capitalize(text) {
      if (text) {
        return text
          .toLowerCase()
          .split(' ')
          .map(s => s.charAt(0).toUpperCase() + s.substring(1))
          .join(' ');
      }
    },
    getLaunchMode(type) {
      switch (type) {
        case 'b2b':
        case 'interface_select_bt':
          return 'Bluetooth';
        case 'interface_select':
          return 'Select';
        case 'interface_select_plus':
          return 'Select+';
        case 'interface_select_plus_plus':
          return 'Select++';
        case 'interface_prime':
          return 'Prime';
      }
    },
    formatDate(date) {
      if (date) {
        return moment(date * 1000).format('MM-DD-YYYY HH:mm');
      }
      return 'Never Active';
    },
    getCheckedOut(arrayOfScreens) {
      return arrayOfScreens.length - this.getCheckedIn(arrayOfScreens);
    },
    getOverdue(arrayOfScreens) {
      let count = 0;
      for (let i = 0; i < arrayOfScreens.length; i++) {
        if (
          arrayOfScreens[i].session_status === 'checked out' &&
          moment().isAfter(arrayOfScreens[i].expected_end_at, 'minute')
        ) {
          count++;
        }
      }
      return count;
    },
    getOneway(arrayOfScreens) {
      return arrayOfScreens.length - this.getRoundtrip(arrayOfScreens);
    },
    getRoundtrip(arrayOfScreens) {
      let count = 0;
      for (let i = 0; i < arrayOfScreens.length; i++) {
        if (
          arrayOfScreens[i].trip_type === 'round trip' ||
          arrayOfScreens[i].trip_type === 'digital key' ||
          arrayOfScreens[i].trip_type === 'bluetooth'
        ) {
          count++;
        }
      }
      return count;
    },
    getAreaName(id) {
      let areaObject = null;
      this._areas.map(area => {
        if (area.value === id) {
          areaObject = area;
        }
      });
      if (areaObject) {
        return areaObject.text;
      }
      return id;
    },
    getGroupArea(screens) {
      const monthAgo = moment()
        .subtract(1, 'months')
        .format('YYYY-MM-DD');
      let isActive = 'No';
      screens.map(screen => {
        const last_activity = moment(screen.last_activity).format('YYYY-MM-DD');
        if (last_activity > monthAgo) {
          isActive = 'Yes';
        }
      });
      return isActive;
    },
  },
};
</script>
